import React from 'react';
import styles from './NotFoundPage.module.scss';
import { useSolutionPicker } from 'hooks/useSolutionPicker';
import { SolutionPickerModule } from 'components/SolutionPickerModule/SolutionPickerModule';
import { SolutionPickerEntryId } from 'api/contentful/solutionPickerEntryIds';
import notFound from 'images/404-image-lockup.svg';
import { Image } from 'components/Image/Image';

export const NotFoundPage: React.FC = () => {
  const entries = useSolutionPicker(SolutionPickerEntryId.NOT_FOUND_PAGE);
  if (!entries) return null;
  return (
    <>
      <Image className={styles.notFoundImage} src={notFound} aria-hidden="true" />
      <div className={styles.solutionPickerWrap}>
        <SolutionPickerModule entry={entries} />
      </div>
    </>
  );
};
